import React from "react";
import "./Footer.css";
import { Button } from "react-bootstrap";
import play from "../../../Assets/Images/appstore.png";
import { animateScroll as scroll } from "react-scroll"; // Import animateScroll from react-scroll
import { Link, useNavigate } from "react-router-dom"; // Import Link from react-router-dom

import Support from "../../../Auth/Support/Support";

export default function Footer() {
  const [modalShow, setModalShow] = React.useState(false);
  const navigate = useNavigate();
  const scrollTo = (elementId) => {
    scroll.scrollTo(elementId, {
      smooth: true,
      // offset: -70,
      offset: 0,
      duration: 100,
    });
  };
  const handleNavigation = (section) => {
    navigate("/", { state: { scrollToSection: section } });
  };
  return (
    <div className="Footer bg-gray-900 paddingRespo">
      <div className="container">
        <footer className="py-5 pb-2">
          <div className="row py-4 ">
            <h1 className="text-white text-center py-2">Get our mobile app</h1>
            <h5 className="py-1 bgBio text-center">
              Available for Desktop and Android
            </h5>
          </div>

          <div className="row py-5 ">
            <div className="d-flex justify-content-center">
              {/* <img src={app} className="img-fluid px-3" alt="d" /> */}
              <a
                target="_blank"
                // href="https://drive.google.com/uc?export=download&id=1FqMjgw5RYoWBaQsqjV9G6fKWESrKE-IM"
                href="https://play.google.com/store/apps/details?id=com.app.myvpn123&pli=1"
              >
                <img src={play} className="img-fluid px-3" alt="d" />
              </a>
            </div>
          </div>
          <div className="row">
            <div className="col-6 col-md-3 mb-3">
              <h5 className="footHead">Site Map</h5>
              <ul className="nav flex-column">
                <li className="nav-item mb-2">
                  <Link to="/" className="text-decoration-none">
                    <span className="cursor-pointer nav-link p-0 text-white">
                      Home
                    </span>
                  </Link>
                </li>
                <li className="nav-item mb-2">
                  <span
                    // onClick={() => scrollTo("features")}
                    onClick={() => handleNavigation("features")}
                    className="cursor-pointer nav-link p-0 text-white"
                  >
                    Features
                  </span>
                </li>

                <li className="nav-item mb-2">
                  <Link to="/aboutus" className="text-decoration-none">
                    <span className="cursor-pointer nav-link p-0 text-white">
                      About
                    </span>
                  </Link>
                </li>
                {/*<li className="nav-item mb-2" onClick={() => setModalShow(true)}>
                  <span className="cursor-pointer nav-link p-0 text-white">
                    Support
                  </span>
                </li>
                 */}
              </ul>
            </div>

            <div className="col-6 col-md-3 mb-3">
              <h5 className="footHead">Download</h5>
              <ul className="nav flex-column">
                {/* <li className="nav-item mb-2">
                  <a href="#" className="nav-link p-0 text-white">
                    VPN for mac
                  </a>
                </li>
                <li className="nav-item mb-2">
                  <a href="#" className="nav-link p-0 text-white">
                    VPN for iOS
                  </a>
                </li> */}

                <li className="nav-item mb-2">
                  {/* <span
                    onClick={() => scrollTo("appSection")}
                    className="cursor-pointer nav-link p-0 text-white"
                  > */}
                  <a
                    className="cursor-pointer nav-link p-0 text-white"
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=com.app.myvpn123&pli=1"
                  >
                    VPN for Andorid
                  </a>
                  {/* </span> */}
                </li>

                <li className="nav-item mb-2">
                  <a
                    className="cursor-pointer nav-link p-0 text-white"
                    target="_blank"
                    download="123MyVPN-setup-64bit.msi"
                    href="/123MyVPN-setup.msi"
                  >
                    VPN for Windows
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-3 mb-3">
              <h5 className="footHead">Support</h5>
              <ul className="nav flex-column">
                <li className="nav-item mb-2">
                  <span className="cursor-pointer nav-link p-0 text-white">
                    Live Chat
                  </span>
                </li>
                <li className="nav-item mb-2">
                  <span className="cursor-pointer nav-link p-0 text-white">
                    FAQs
                  </span>
                </li>
                <Link to="/howitworks" className="text-decoration-none mb-2">
                  <span className="cursor-pointer nav-link p-0 text-white">
                    VPN Tutorials
                  </span>
                </Link>

                <li
                  className="nav-item mb-2"
                  onClick={() => setModalShow(true)}
                >
                  <span className="cursor-pointer nav-link p-0 text-white">
                    Contact Us
                  </span>
                  {/* <a  href="mailto:contact@123myvpn.com"  className="cursor-pointer nav-link p-0 pt-2 text-blue text-decoration-underline">
                  contact@123myvpn.com
                  </a> */}
                </li>
              </ul>
            </div>

            <div className="col-md-2  mb-3">
              <form>
                <h5 className="footHead">Follow Us</h5>
                <div className="py-2 ms ps-0 d-flex">
                  <span className="social-icon bg-twitter">
                    <i className="fa fa-twitter"></i>
                  </span>
                  <span className="social-icon bg-facebook">
                    <i className="fa fa-instagram"></i>
                  </span>

                  <span className="social-icon bg-skype">
                    <i className="fa fa-facebook"></i>
                  </span>
                </div>
                <h5 className="footHead py-3">Live Chat</h5>

                <div className="d-flex flex-column flex-sm-row w-100 gap-2">
                  <Button className="btn btn-default humanBg startedBtn rounded-5 pt-3 pb-3 px-4 my-2">
                    Talk to a human
                  </Button>
                </div>
              </form>
            </div>
          </div>

          <div className="d-flex flex-column flex-sm-row justify-content-between bgBio py-4">
            © Copyright 2024. All rights reserved.
          </div>
        </footer>
        <Support show={modalShow} onHide={() => setModalShow(false)} />
      </div>
    </div>
  );
}
